import { NewPaymentMethodFormValues } from '../../models';

export class FetchPatientPaymentMethods {
  static readonly type = '[Patient Payment Methods] Fetch Patient Payment Methods';
}

export class CreatePatientPaymentMethod {
  static readonly type = '[Patient Payment Methods] Create Payment Method';
  constructor(public formValues: NewPaymentMethodFormValues) {}
}

export class SetDefaultPatientPaymentMethod {
  static readonly type = '[Patient Payment Methods] Set Default Payment Method';
  constructor(public paymentMethodId: string) {}
}
